/**
 * LanguageProvider 使用 EN | DE | CN；内容 JSON（诗人名、bio 等）使用小写 zh | de | en。
 */
export function appLanguageToContentLocale(language: string): 'zh' | 'de' | 'en' {
  const u = language?.toUpperCase?.() || 'CN'
  if (u === 'DE') return 'de'
  if (u === 'EN') return 'en'
  return 'zh'
}
